import {DELETE_ALERT} from "../../../constants/LiveConstants";
import {DeleteAlertMarketPayload, GeneralAction} from "../../../@types/actions";

export const DeleteAlertAction = (data: DeleteAlertMarketPayload): GeneralAction<DeleteAlertMarketPayload> => ({
    type: DELETE_ALERT,
    payload: data
});
